import { Refine } from "@pankod/refine-core";
import {
  notificationProvider,
  Layout,
  LoginPage,
  ReadyPage,
  ErrorComponent,
} from "@pankod/refine-antd";
import "@pankod/refine-antd/dist/styles.min.css";
import routerProvider from "@pankod/refine-react-router-v6";
import "./dayjsConfig";
import httpClient from "./httpClient";
import authProvider from "./authProvider";
import dataProvider from "./dataProvider";
import { QuizList, QuizCreate, QuizShow, QuizEdit } from "pages/quiz";
import { QuizCategoryList, QuizCategoryCreate, QuizCategoryEdit, QuizCategoryShow } from "pages/quizCategory";
import { LanguageList, LanguageCreate, LanguageEdit, LanguageShow } from "pages/language";
import { MessageList, MessageCreate, MessageEdit, MessageShow } from "pages/message";
import { NewsList, NewsCreate, NewsEdit, NewsShow } from "pages/news";
import { EventList, EventCreate, EventEdit, EventShow } from "pages/event";
import { EventTypeList, EventTypeCreate, EventTypeEdit, EventTypeShow } from "pages/eventType";
import { UserList, UserCreate, UserEdit, UserShow } from "pages/user";
import { VerificationJobList, VerificationJobShow } from "pages/verification";
import { QuizAICreationList, QuizAICreationShow } from "pages/quizAICreation";
import { AppVersionList, AppVersionCreate, AppVersionEdit, AppVersionShow } from "pages/appVersion";
import { ServiceAccountList, ServiceAccountCreate, ServiceAccountEdit, ServiceAccountShow } from "pages/serviceAccount";
import { useTranslation } from "react-i18next";
import { Header } from "components/layout";
import "./index.css"

function App() {
  const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:8080";
  const BASE_PATH = process.env.REACT_APP_BASE_PATH || "/";
  const { t, i18n } = useTranslation();

  const i18nProvider = {
    translate: (key: string, params: object) => t(key, params),
    changeLocale: (lang: string) => i18n.changeLanguage(lang),
    getLocale: () => i18n.language,
  };

  const { RouterComponent } = routerProvider;

  const CustomRouterComponent = () => <RouterComponent basename={BASE_PATH} />;

  return (
    <Refine
      reactQueryClientConfig={{
        defaultOptions: {
          queries: {
            cacheTime: 0,
          },
        },
      }}
      notificationProvider={notificationProvider}
      Layout={Layout}
      LoginPage={LoginPage}
      ReadyPage={ReadyPage}
      catchAll={<ErrorComponent />}
      routerProvider={{
        ...routerProvider,
        RouterComponent: CustomRouterComponent,
    }}
      authProvider={authProvider(`${BASE_URL}/api/v2/user/login`, httpClient)}
      dataProvider={dataProvider(`${BASE_URL}/api/v2`, httpClient)}
      resources={[
        {
          name: "quiz",
          list: QuizList,
          create: QuizCreate,
          edit: QuizEdit,
          show: QuizShow,
        },
        {
          name: "quiz-category",
          list: QuizCategoryList,
          create: QuizCategoryCreate,
          edit: QuizCategoryEdit,
          show: QuizCategoryShow,
        },
        {
          name: "language",
          list: LanguageList,
          create: LanguageCreate,
          edit: LanguageEdit,
          show: LanguageShow,
        },
        {
          name: "message",
          list: MessageList,
          create: MessageCreate,
          edit: MessageEdit,
          show: MessageShow,
        },
        {
          name: "news",
          list: NewsList,
          create: NewsCreate,
          edit: NewsEdit,
          show: NewsShow,
        },
        {
          name: "event",
          list: EventList,
          create: EventCreate,
          edit: EventEdit,
          show: EventShow,
        },
        {
          name: "event-type",
          list: EventTypeList,
          create: EventTypeCreate,
          edit: EventTypeEdit,
          show: EventTypeShow,
        },
        {
          name: "user",
          list: UserList,
          create: UserCreate,
          edit: UserEdit,
          show: UserShow,
        },
        {
          name: "verification-jobs",
          list: VerificationJobList,
          show: VerificationJobShow,
          options: { label: "Verification" },
        },
        {
          name: "quiz-ai-creation",
          list: QuizAICreationList,
          show: QuizAICreationShow,
          options: { label: "AI Quiz Creation" },
        },
        {
          name: "app-version",
          list: AppVersionList,
          create: AppVersionCreate,
          edit: AppVersionEdit,
          show: AppVersionShow,
        },
        {
          name: "service-account",
          list: ServiceAccountList,
          create: ServiceAccountCreate,
          edit: ServiceAccountEdit,
          show: ServiceAccountShow,
          options: { label: "Service Accounts" },
        },
      ]}
      i18nProvider={i18nProvider}
      Header={Header}
    />
  );
}

export default App;
